// --------------------------------------------------------
// CARD PERIODIC ATENDIMENTO AREA - CardPeriodicAtendimentoArea
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useState } from "react";
import Colors from "../../constants/Colors";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GenericSolidButton } from "../UI/buttons/Button.styled";
import { Text } from "../UI/generalLayout/Layout.styled";
import { ReactComponent as Medic } from "../../assets/imgs/medicIcon.svg";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { checkForeseeableDate } from "../../helpers/HelperFunctions";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARD PERIODIC ATENDIMENTO AREA INTERFACE
// --------------------------------------------------------

interface ICardPeriodicAtendimentoArea {
  data: any;
  onClickInnerSetAppointment: () => void;
  isCareLine: boolean;
  isFromProntuario?: boolean;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardPeriodicAtendimentoArea = ({
  data,
  isCareLine,
  isFromProntuario = false,
  onClickInnerSetAppointment,
}: ICardPeriodicAtendimentoArea) => {
  // --------------------------------------------------------
  // CARD PERIODIC ATENDIMENTO AREA PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();
  const [dataPrevista, setDataPrevista] = useState({
    nome: "",
    outdated: false,
  });

  const PendingIcon = () => {
    return <HighlightOffIcon style={{ color: "#64748B", marginTop: 14 }} />;
  };

  useEffect(() => {
    if (data.dataPrevista != null) {
      const nextDate = checkForeseeableDate(data.dataPrevista);
      setDataPrevista(nextDate);
    }
  }, []);

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {!isMobile ? (
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <div style={{ flexDirection: "row", display: "flex", width: "25%" }}>
            <Medic style={{ marginRight: 10 }} />
            {isCareLine ? <Text>Atendimento</Text> : <Text>Periódico</Text>}
          </div>
          <div style={{ width: "25%" }}>
            {dataPrevista.nome !== undefined && (
              <Text color={dataPrevista.outdated ? Colors.error : ""}>
                {dataPrevista.nome}
              </Text>
            )}
          </div>
          <div style={{ width: "35%" }}>
            <Text>{data.nome}</Text>
          </div>
          <div style={{ textAlign: "center", width: "25%" }}>
            {dataPrevista.outdated ? (
              <>
                {!isFromProntuario && (
                  <GenericSolidButton
                    color={Colors.RED700}
                    onClick={onClickInnerSetAppointment}
                  >
                    Marcar consulta
                  </GenericSolidButton>
                )}
              </>
            ) : (
              <div style={{ display: "flex", flexDirection: "row", gap: 5 }}>
                <PendingIcon />
                <Text>Pendente</Text>
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Medic
                width={60}
                height={60}
                style={{ marginRight: 10, marginTop: 30 }}
              />
            </div>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                width: "100%",
              }}
            >
              <Text style={{ marginTop: 40 }}>Periódico</Text>
              <Text style={{ marginBottom: -5, marginTop: -15 }}>
                {data.nome}
              </Text>
            </div>
          </div>
          <div>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Text>{`Data prevista: ${
                data.dataPrevista !== null ? dataPrevista.nome : ""
              }`}</Text>
              {/* {dataPrevista.outdated? (<GenericSolidButton color={Colors.RED700} onClick={onClickInnerSetAppointment}>
                        Marcar consulta
                    </GenericSolidButton>):(<Text>Pendente</Text>)} */}
            </div>
          </div>
        </>
      )}
    </>
  );
  // --------------------------------------------------------
};

export default CardPeriodicAtendimentoArea;
